import React from "react";
import PageWrapper from "./PageWrapper";
import * as Const from "./../_Const";
const WarningPage = ({ title, subtitle, message, index }) => {
  const isTerminal = Const.isTerminal();
  const titleCss = isTerminal ? "text-6xl" : "text-[1.92rem]";
  const textCss = isTerminal ? "text-4xl mt-28" : "text-xl mt-8";

  function replaceWithBr(text) {
    return text?.replace(/\n/g, "<br />") ?? text;
  }
  return (
    <PageWrapper title={title} index={index}>
      <div className="mt-8 flex flex-col">
        <div className="bg-error mx-6 h-36 flex justify-center items-center">
          <p className={`${titleCss} text-white uppercase`}>{message}</p>
        </div>
        <p className={`${textCss} text-center text-accent-dark dark:text-accent`}>
          <span dangerouslySetInnerHTML={{ __html: replaceWithBr(subtitle) }} />
        </p>
      </div>
    </PageWrapper>
  );
};

export default WarningPage;
